import setForwardingEmailAddress from '../actions/setForwardingEmailAddress';
import setKeepCopyState from '../actions/setKeepCopyState';
import ForwardingOptionState from '../store/schema/ForwardingOptionState';
import store from '../store/store';
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import getForwardingEmailAddress from '../utils/getForwardingEmailAddress';
import getKeepCopy from '../utils/getKeepCopy';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { OptionsCheckbox } from 'owa-options-controls';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const styles = require('./ForwardingForm.scss');

export interface ForwardingFormProps {
    optionState?: ForwardingOptionState;
}

@reactive({
    optionState: () => store,
})
export default class ForwardingForm extends React.Component<ForwardingFormProps, {}> {
    render() {
        const isForwardingEnabled = getChoiceGroupSelection() === 'start';
        const forwardingEmailAddress = isForwardingEnabled ? getForwardingEmailAddress() : '';
        const keepCopy = isForwardingEnabled ? getKeepCopy() : false;

        /**
         * Show the error message if:
         *  - "Start forwarding" is checked
         *  - The user has entered text in the input
         *  - The text in the input is invalid
         */
        const showErrorMessage =
            isForwardingEnabled &&
            !isValidEmailAddress(forwardingEmailAddress) &&
            forwardingEmailAddress !== null;

        return (
            <div className={styles.formContainer}>
                <Label className={styles.label}>{strings.options_forwarding_input_label}</Label>
                <TextField
                    className={styles.emailInput}
                    value={forwardingEmailAddress}
                    onChanged={this.onEmailAddressChanged}
                    disabled={!isForwardingEnabled}
                    placeholder={strings.options_forwarding_input_placeholder}
                    errorMessage={showErrorMessage ? strings.options_forwarding_input_error : null}
                />
                <OptionsCheckbox
                    label={strings.options_forwarding_keepCopy_label}
                    checked={keepCopy}
                    onChange={this.onKeepCopyStateChanged}
                    disabled={!isForwardingEnabled}
                />
            </div>
        );
    }

    private onEmailAddressChanged = (text: string) => {
        setForwardingEmailAddress(text);
    };

    private onKeepCopyStateChanged = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        setKeepCopyState(checked);
    };
}
